import { useState } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, CircularProgress } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import PageService from '../../services/PageService'

const DeleteTestCasesConfirmationModal = ({
  deleteOpen,
  setDeleteOpen,
  tabToggler,
  setTabToggler,
  testCasesToDelete,
  setCheckedTestCases,
  deleteContext = {},
  refreshHierarchy,
  onAfterDelete
}) => {
  const [loading, setLoading] = useState(false)
  const isCycleContext = deleteContext?.mode === 'cycle'
  const cycleItemIds = Array.isArray(deleteContext?.cycleItemIds)
    ? deleteContext.cycleItemIds.filter(Boolean)
    : []
  const pageIds = Array.isArray(deleteContext?.pageIds)
    ? deleteContext.pageIds.filter(Boolean)
    : []
  const cycleId = deleteContext?.cycleId || null

  const handleCloseDeleteDialog = () => {
    setDeleteOpen(false)
  }

  const handleDeleteTestCases = async () => {
    setLoading(true)
    try {
      if (isCycleContext) {
        if (cycleItemIds.length) {
          await Promise.all(cycleItemIds.map((id) => PageService.removeCycleItem(id)))
        } else if (cycleId && pageIds.length) {
          const uniquePageIds = [...new Set(pageIds)]
          await Promise.all(uniquePageIds.map((pageId) => PageService.removeCyclePage(cycleId, pageId)))
        } else {
          setLoading(false)
          return
        }
      } else {
        await PageService.deleteTestCases(testCasesToDelete)
      }
      setCheckedTestCases([])
      setTabToggler(!tabToggler)
      if (typeof refreshHierarchy === 'function') {
        refreshHierarchy()
      }
      if (typeof onAfterDelete === 'function') {
        onAfterDelete(testCasesToDelete)
      }
      setDeleteOpen(false)
    } catch (error) {
      console.log(error.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog
      open={deleteOpen}
      onClose={handleCloseDeleteDialog}
    >
      <Box className="deleteTestCasesModal">
        <DialogTitle className="deleteTestCasesModalTitle">
          Confirm Delete Test Case
          {testCasesToDelete.length > 1 && "s"}
        </DialogTitle>
        <DialogContent className="deleteTestCasesModalContent">
          <DialogContentText className="deleteTestCasesModalContentText">
            {isCycleContext
              ? `Are you sure you want to remove ${testCasesToDelete.length > 1 ? 'these' : 'this'} test case${testCasesToDelete.length > 1 ? 's' : ''} from the project version? They will stay available in Blueprints.`
              : `Are you sure you want to delete ${testCasesToDelete.length > 1 ? 'these' : 'this'} test case${testCasesToDelete.length > 1 ? 's' : ''}? This will permanently remove ${testCasesToDelete.length > 1 ? 'them' : 'it'} from the system, and it cannot be restored.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions className="deleteTestCasesModalActions">
          <Button className="deleteTestCasesModalButton" onClick={handleCloseDeleteDialog} color="secondary" variant="outlined">
            Cancel
          </Button>
          {loading ? (
            <LoadingButton
              loading
              className="deleteTestCasesModalButton"
              variant="contained"
              loadingIndicator={<CircularProgress color="white" size={16} />}
            />
          ) : (
            <Button className="deleteTestCasesModalButton" onClick={handleDeleteTestCases} color="error" variant="contained" autoFocus>
              Delete
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default DeleteTestCasesConfirmationModal
